export default "__VITE_ASSET__8cb9daef__"